/* globals CWB_API_ENV */
import React, { useEffect } from 'react';
import { Input } from 'reactstrap';
import { getI18n, Trans, withI18n } from 'react-i18next'
import { client } from "shared/apiClient";
import CWBLogoGrey from "images/icon-cwb-logo-grey.svg";
import styled, { css } from "styled-components";
import { redirectToLogin, redirectAuthenticated } from "shared/helpers";
import { withRouter } from "react-router-dom";
import {
    CWBAPI,
    CWBLoadingCrest,
    getSessionDataFromAuthToken,
    setUserAuthToken,
} from "cwb-react";
import qs from "query-string";


const Go = ({
    location,
    t,
}) => {

    useEffect(() => {
        async function tryAutoLogin() {
            let api = await import(`cwb-react/dist/${CWB_API_FILE}`);
            let localApi = await import(`shared/api`);
            client.api = new CWBAPI(
                { ...api.default, ...localApi.default },
                CWB_API_ENV,
                CWB_USE_MOCK_ENV
            );
            let tokenAttempt = false;
            let queryStringData = null;

            const tryCompleteAutoLogin = (tokenResp) => {
                const authToken = tokenResp && tokenResp.data && tokenResp.data.accessToken;
                if (authToken) {
                    const decoded = getSessionDataFromAuthToken(authToken);
                    delete queryStringData.k;
                    delete queryStringData.tk;
                    redirectAuthenticated(
                        decoded.UserType,
                        decoded.WebSessionKey,
                        decoded.UserId,
                        queryStringData,
                        authToken
                    );
                } else {
                    delete queryStringData.k;
                    delete queryStringData.tk;
                    redirectToLogin(`${qs.stringify(queryStringData)}`);
                }
            }

            try {
                queryStringData = qs.parse(location.search);
                let tokenResp = null;
                if (!queryStringData.k && !queryStringData.tk) {
                    tokenResp = await client.api.user.getAuthToken();
                } else {
                    tokenResp = await client.api.user.postBridgeAuthTokenFromSession(queryStringData.k || queryStringData.tk);
                    tokenAttempt = true;
                }
                tryCompleteAutoLogin(tokenResp);
            } catch (ex) {
                if (queryStringData) {
                    delete queryStringData.k;
                    delete queryStringData.tk;
                    if (tokenAttempt) {
                        tokenResp = await client.api.user.getAuthToken();
                        tryCompleteAutoLogin(tokenResp);
                    } else {
                        redirectToLogin(`?${qs.stringify(queryStringData)}`);
                    }
                } else {
                    redirectToLogin(location.search);
                }
            }
        }

        tryAutoLogin();
    }, []);

    return (
        <StyledDiv isCWBLabs={false}>
            <CWBLoadingCrest customLogoSrc={CWBLogoGrey} />
        </StyledDiv>
    )
}
const StyledDiv = styled.div`
  ${(p) =>
        p.isCWBLabs &&
        css`
      height: calc(100% - 80px);
      background-color: #040f1c;
    `}
`;
export default withI18n()(withRouter(Go));
